module.exports = __webpack_public_path__ + "img/perImg1.4f6e67e3.png";